module.exports = __webpack_public_path__ + "static/media/nynfc4.b2c8fd97.jpg";